import { Compass } from 'lucide-react';
import { Link } from 'react-router';
import { Page } from '../components/layout';
import { Button, EmptyState } from '../components/ui';
import { useT } from '../i18n';

export default function NotFound() {
  const t = useT();
  return (
    <Page>
      <EmptyState
        icon={Compass}
        title={t('error.not_found')}
        action={
          <Link to="/">
            <Button>{t('nav.home')}</Button>
          </Link>
        }
      />
    </Page>
  );
}
